import React from 'react';
import { Box, Text } from '@medely/ui-kit';
import { ContentLoader, PageLayout, PageLayoutContent } from '@mp/components';
import { ShiftSwapReviewItem } from './ShiftSwapReviewItem';
import { useCurrentUser } from '@mp/hooks';
import { getShiftSwaps } from './graphql';

export const ShiftSwaps = () => {
  const { currentUser, isLoading: isUserLoading } = useCurrentUser();
  const { shiftRequests, isLoading } = getShiftSwaps({ accountId: currentUser?.id });

  const hasNoShiftRequests = !isLoading && shiftRequests.length === 0;

  return (
    <PageLayout
      handleBack={() => {
        return;
      }}
      backButtonText="Back"
      title={currentUser?.company?.name}
    >
      <ContentLoader loading={isLoading || isUserLoading}>
        <PageLayoutContent>
          {hasNoShiftRequests ? (
            <Text>No shift swap requests available.</Text>
          ) : (
            <Box px={4}>
              {shiftRequests?.map((shiftRequest) => (
                <ShiftSwapReviewItem
                  key={shiftRequest.id}
                  job={shiftRequest.job}
                  shiftRequestId={shiftRequest.id}
                />
              ))}
            </Box>
          )}
        </PageLayoutContent>
      </ContentLoader>
    </PageLayout>
  );
};
